import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/pt-br'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'

dayjs.extend(relativeTime)
dayjs.locale('pt-br')
import { useState } from 'react'

import { formatCurrency } from '@/_helpers/currency'
import { formatCpf } from '@/_helpers/cpf'

import type { TUserType } from '../../_lib/auth-client.types'
import type { TStaffApplicationListItem } from '../../_lib/api/entities/applications.staff'
import { getStatusConfig } from '../../_constants/admission-status'

type KanbanCardApplication = TStaffApplicationListItem & {
  facilityName?: string
}

export interface ApplicationKanbansCardProps {
  application: KanbanCardApplication
  userType: TUserType
}
export function ApplicationKanbansCard({ application, userType }: ApplicationKanbansCardProps) {
  const [toggle, setToggle] = useState(false)
  const statusConfig = getStatusConfig(application.status, userType)
  const amount = application.proposal?.disbursementAmount ?? application.requestedAmount

  return (
    <div className="flex flex-col divide-y divide-brand-grayscale-3">
      <div className="flex flex-col gap-y-1.5 p-4">
        <span className="text-sm font-semibold">{application.person?.name || '-'}</span>
        {application.person?.cpf && (
          <span className="text-xs text-brand-grayscale-6">
            {formatCpf(application.person.cpf)}
          </span>
        )}
        {application.facilityName && (
          <span className="text-xs text-brand-grayscale-6">{application.facilityName}</span>
        )}
        <span className="text-sm font-semibold text-brand-grayscale-7">
          {amount ? formatCurrency(Number(amount)) : '—'}
        </span>
      </div>
      <div className="flex flex-row items-center justify-between px-4 py-3">
        {application.guarantors && application.guarantors.length > 0 ? (
          <div
            onClick={() => {
              setToggle((prev) => !prev)
            }}
            className="flex cursor-pointer flex-row items-center gap-x-1"
          >
            <span className="text-xs font-medium">
              {application.guarantors.length === 1
                ? '1 Avalista'
                : `${application.guarantors.length} Avalistas`}
            </span>
            {toggle ? <ChevronUpIcon size={14} /> : <ChevronDownIcon size={14} />}
          </div>
        ) : (
          <div />
        )}
        <span className="text-xs font-medium text-brand-grayscale-6">
          {dayjs(application.createdAt).fromNow()}
        </span>
      </div>
      {application.guarantors && application.guarantors.length > 0 && toggle && (
        <div className="flex flex-col gap-y-1 px-4 py-3">
          {application.guarantors.map((guarantor, index) => (
            <div
              className="flex flex-col gap-y-1 rounded-[12px] border border-brand-grayscale-3 px-4 py-3"
              key={index}
            >
              <div className="flex flex-row gap-x-1 text-[10px] font-normal">
                <span>Status de avaliação: </span>
                <span
                  style={{
                    color: statusConfig?.color,
                  }}
                >
                  {statusConfig?.label}
                </span>
              </div>
              <span className="text-xs font-semibold">{guarantor.name || '-'}</span>
              <span className="text-xs font-normal">
                {guarantor.cpf ? formatCpf(guarantor.cpf) : '-'}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
